// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__2w6Ep","actionsCol":"EnrolledClinics_actionsCol__1m88u"};